import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import MultiSelect from "../form/select/MultiSelect";
import Select from "../form/select/Select";
import { flashMessage as flash } from "./../../utils/flash/index";
import {
  getEmptyKey,
  objectCheck,
} from "../../utils/helpers/filter";
import SavingsPolicyPreview from "../modals/preview/SavingsPolicyPreview";

const SavingsSettings = ({
  accountingRef,
  policyConfig,
  coverRef,
  genInfoRef,
  interestRef,
  policyCreateCloseRef,
}) => {
  const {
    offices: { offices },
  } = useSelector((state) => state?.office);
  // const { unpaginated_charges } = useSelector((state) => state?.charges);

  const [subDisable, setSubDisable] = useState(false);
  // const [specOfficeDisable, setSpecOfficeDisable] = useState(false);
  const [data, setData] = useState(null);

  const rabRef = useRef();
  const subOfficeRef = useRef(null);
  const soRef = useRef(null);
  const preview = useRef();

  const onSubmit = (values) => {
    // const arr = values?.charges
    //   ? values?.charges?.map((item) => ({
    //       charge_id: item?.value,
    //     }))
    //   : [];

    let payload = {
      // charges: [...arr],
      expires_at: values?.expires_at,
    };

    let company_wide;
    let sub_offices;

    // if (values.charges) {
    //   charges = values.charges.map(item => ({ charge_id: item.value }));
    // }

    // structuring data to fit backend request
    if (values?.apply_to === "CW") {
      payload = {
        ...payload,
        company_wide: true,
      };
      company_wide = 1;
    } else if (values?.apply_to === "RAB") {
      if (!values?.region_area_branch)
        return flash("error", "A region/area/branch must be selected to apply");
      payload = {
        ...payload,
        region_area_branch: values?.region_area_branch,
        apply_sub_offices: values?.apply_sub_offices,
      };
      sub_offices = values?.apply_sub_offices;
    } else {
      const specific_offices1 = values?.specific_offices?.map((item) => ({
        office_id: item?.value,
      }));

      payload = {
        ...payload,
        specific_offices: [...specific_offices1],
      };
      // specific_offices = values.specific_offices.map(item =>  ({ office_id: item.value }))
    }

    // get all required fields names that are empty
    let emptyPI = getEmptyKey(policyConfig?.policy_savings_general);
    let emptyPR = getEmptyKey(policyConfig?.policy_savings_interest);

    // check whether all required fields have been filled
    if (emptyPI !== "description" && emptyPI !== null) {
      flash("error", `${emptyPI} is required`);
      genInfoRef?.current?.click();
      return;
    }

    // check whether minimum age is greater than maximum age
    if (
      parseInt(policyConfig?.policy_savings_general?.minimum_age) >
      parseInt(policyConfig?.policy_savings_general?.maximum_age)
    ) {
      genInfoRef?.current?.click();
      return;
    }

    // check if there atleast one cover for. If not, go to cover for tab.
    // if (policyConfig?.cover_type?.every((item) => item === "")) {
    //   coverRef?.current?.click();
    //   flash("error", "Atleast one cover is required");
    //   return;
    // }
    // check if there atleast one cover for. If not, go to cover for tab.
    if (policyConfig?.life_cover?.every((item) => item === "")) {
      coverRef?.current?.click();
      flash("error", "Atleast one life cover is required");
      return;
    }

    if (policyConfig?.life_cover_claim_name === 'multiple' && policyConfig?.value?.length < 1) {
      coverRef?.current?.click();
      flash("error", "Atleast one multiple value is required");
      return;
    }
    
    if (policyConfig?.life_cover_claim_name === 'guaranteed' && policyConfig?.guaranteed_type === "fixed" && policyConfig?.value === "") {
      coverRef?.current?.click();
      flash("error", "Fixed value is required");
      return;
    }
    
    if (policyConfig?.life_cover_claim_name === 'guaranteed' && policyConfig?.guaranteed_type === "range" && (policyConfig?.assumed_garranty_maximum === "" || policyConfig?.assumed_garranty_minimum === "")) {
      coverRef?.current?.click();
      flash("error", "Both minimum and maximum values are required");
      return;
    }
    
    if (policyConfig?.life_cover_claim_name === 'guaranteed' && policyConfig?.guaranteed_type === "range" && (parseFloat(policyConfig?.assumed_garranty_maximum) < parseFloat(policyConfig?.assumed_garranty_minimum) )) {
      coverRef?.current?.click();
      flash("error", "Minimum cannot be greater than Maximum");
      return;
    }

    // check if minimum rate is not greater than maximum rate and default rate not greater than less or greater than minimum and maximum respectively
    if (
      parseFloat(policyConfig?.policy_savings_interest?.default_interest_rate) <
        parseFloat(
          policyConfig?.policy_savings_interest?.minimum_interest_rate
        ) ||
      parseFloat(policyConfig?.policy_savings_interest?.default_interest_rate) >
        parseFloat(policyConfig?.policy_savings_interest?.maximum_interest_rate)
    ) {
      interestRef?.current?.click();
      return;
    }

    // if (!policyConfig?.policy_savings_interest?.interest_cal_type) {
    //   interestRef?.current?.click();
    //   flash("error", "Interest Calculation Type is required");
    //   return;
    // }
    // if (!policyConfig?.policy_savings_interest?.interest_posting_period) {
    //   interestRef?.current?.click();
    //   flash("error", "Interest Posting Period is required");
    //   return;
    // }
    // if (!policyConfig?.policy_savings_interest?.interest_compound_period) {
    //   interestRef?.current?.click();
    //   flash("error", "Interest Compound Period is required");
    //   return;
    // }

    // Check for rate for any empty fields since all are required.
    if (emptyPR) {
      interestRef?.current?.click();
      flash("error", `${emptyPR} is required`);
      return;
    }

    // check if atleast one GL account has been selected
    if (objectCheck(policyConfig?.policy_savings_accounting)) {
      accountingRef?.current?.click();
      flash("error", "Atleast one account GL is required");
      return;
    }

    const partial_withdrawal = {
      max_withdrawal_limit: values.max_withdrawal_limit,
      withdrawal_penalty: values.withdrawal_penalty,
    };

    const termination = {
      penalty_period: values.penalty_period,
      penalty_value: values.penalty_value,
    };

    const cool_off = {
      cool_off_period: values.cool_off_period,
      cool_off_value: values.cool_off_value,
    };

    // send data to preview modal
    setData({
      ...policyConfig,
      payload,
      ...values,
      company_wide,
      sub_offices,
      partial_withdrawal,
      termination,
      cool_off,
    });
    preview?.current?.click();
  };

  

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    setFieldTouched,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      apply_to: "CW",
      apply_sub_offices: "",
      specific_offices: [],
      charges: [],
      region_area_branch: "",
      expires_at: "",
      // policy_cat_id: 1,
      restrict_withdrawal: "",
      max_withdrawal_limit: "",
      withdrawal_penalty: "",
      penalty_period: "",
      penalty_value: "",
      cool_off_period: "",
      cool_off_value: "",
    },
    validate: (values) => {
      const errors = {};
      if (
        (!values.specific_offices || values.specific_offices.length === 0) &&
        values?.apply_to === "SO"
      ) {
        errors.specific_offices = "At least one specific office is required";
      }
      if (values?.apply_to === "RAB" && !values?.region_area_branch) {
        errors.region_area_branch = "Region/Area/Branch is required";
      }
      if (!values.cool_off_period) {
        errors.cool_off_period = "Cool off period is required";
      }
      if (!values.cool_off_value) {
        errors.cool_off_value = "Cool off value is required";
      }
      if (!values.penalty_value) {
        errors.penalty_value = "Penalty value is required";
      }
      if (!values.penalty_period) {
        errors.penalty_period = "Penalty Period is required";
      }
      if (!values.withdrawal_penalty) {
        errors.withdrawal_penalty = "Withdrawal Penalty is required";
      }
      if (!values.max_withdrawal_limit) {
        errors.max_withdrawal_limit = "Max Withdrawal limit is required";
      }
      return errors;
    },
    onSubmit,
  });

  useEffect(() => {
    // controls the switching of the radio buttons on settings tab.
    // Also clearing of fields previously selected but later unselected
    if (values?.apply_to === "RAB") {
      setFieldTouched("specific_offices", false);
      soRef?.current?.clearValue();
      setSubDisable(false);
      rabRef?.current?.clearValue();
      // setSpecOfficeDisable(true);
    } else if (values?.apply_to === "CW") {
      setFieldTouched("region_area_branch", false);
      rabRef?.current?.clearValue();
      soRef?.current?.clearValue();
      if (values?.apply_sub_offices) {
        subOfficeRef?.current?.click();
      }
      setSubDisable(true);
      // setSpecOfficeDisable(true);
    } else {
      soRef?.current.clearValue();
      rabRef?.current?.clearValue();
      setFieldTouched("region_area_branch", false);
      if (values?.apply_sub_offices) {
        subOfficeRef?.current?.click();
      }
      setSubDisable(true);
    }
  }, [values?.apply_to]);
  

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className=''>
          <h5>Apply to (Office)</h5>
          <div class='form-check my-3'>
            <input
              class='form-check-input me-2'
              type='radio'
              name='apply_to'
              id='apply_to'
              value='CW'
              onChange={handleChange}
              defaultChecked={values?.apply_to === "CW"}
            />
            <label class='form-check-label' for='company_wide'>
              Company wide
            </label>
          </div>
          <div class='form-check'>
            <input
              class='form-check-input me-2'
              type='radio'
              name='apply_to'
              value='RAB'
              onChange={handleChange}
              id='apply_to'
            />
            <label class='form-check-label' for='rab'>
              Region/Area/Branch
            </label>
            {values?.apply_to === "RAB" && (
              <div>
                <Select
                  isError={
                    errors?.region_area_branch && touched?.region_area_branch
                  }
                  name='region_area_branch'
                  ref={rabRef}
                  data={offices?.map((item, i) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  value={values?.region_area_branch}
                  onChange={(selectedOption) =>
                    setFieldValue("region_area_branch", selectedOption?.value)
                  }
                  onBlur={() => {
                    handleBlur({ target: { name: "region_area_branch" } });
                  }}
                  disabled={values?.apply_to !== "RAB"}
                />
                {errors?.region_area_branch && touched?.region_area_branch && (
                  <p className='text-danger mb-0'>
                    {errors?.region_area_branch}
                  </p>
                )}
                <div class='form-check mt-1'>
                  <input
                    class='form-check-input'
                    type='checkbox'
                    value={values?.apply_sub_offices}
                    id='apply_sub_offices'
                    name='apply_sub_offices'
                    onChange={handleChange}
                    ref={subOfficeRef}
                    disabled={values?.apply_to !== "RAB" && subDisable}
                  />
                  <label class='form-check-label' for=''>
                    Apply to sub offices
                  </label>
                </div>
              </div>
            )}
          </div>
          <div class='form-check mt-3'>
            <input
              class='form-check-input me-2'
              type='radio'
              name='apply_to'
              value='SO'
              onChange={handleChange}
              id='apply_to'
            />
            <label class='form-check-label ' for='so'>
              Specific Office(s)
            </label>
            {values?.apply_to === "SO" && (
              <div>
                <MultiSelect
                  isError={
                    errors?.specific_offices && touched?.specific_offices
                  }
                  name='specific_offices'
                  field={{ ...getFieldProps("specific_offices") }}
                  data={offices?.map((item, i) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  onChange={setFieldValue}
                  onBlur={() => {
                    handleBlur({ target: { name: "specific_offices" } });
                  }}
                  errors={errors}
                  touched={touched}
                  disabled={values?.apply_to !== "SO"}
                  ref={soRef}
                />
              </div>
            )}
          </div>
          {/* <div class='form-check mt-3'>
            <label class='form-check-label ' for='so'>
              Add charges
            </label>
            <div>
              <MultiSelect
                isError={errors?.charges && touched?.charges}
                name='charges'
                field={{ ...getFieldProps("charges") }}
                data={unpaginated_charges?.get_savings_charge?.map((item) => ({
                  label: item.charge_name,
                  value: item.id,
                }))}
                onChange={setFieldValue}
                onBlur={() => {
                  handleBlur({ target: { name: "charges" } });
                }}
                errors={errors}
                touched={touched}
                // ref={soRef}
              />
            </div>
          </div> */}
          <div class='form-check mt-3 mb-4'>
            <label class='form-check-label ' for='so'>
              Expires at
            </label>
            <div>
              <input
                name='expires_at'
                value={values?.expires_at}
                className='form-control'
                type='date'
                onChange={handleChange}
              />
            </div>
          </div>
          <div className='border p-3 rounded-3 my-4 position-relative'>
            <h4 className='fw-semibold bg-white position-absolute profile-title'>
              Partial Withdrawal
            </h4>
            <div className='row'>
              <div className='col-md-4 mb-3'>
                <label htmlFor='default_rate'>
                  Max. withdrawal limit before maturity(%)
                  <span className='text-danger'>*</span>
                </label>
                <input
                  type='text'
                  className={`form-control ${
                    errors?.max_withdrawal_limit &&
                    touched?.max_withdrawal_limit &&
                    "is-invalid"
                  }`}
                  name='max_withdrawal_limit'
                  id='max_withdrawal_limit'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='%'
                />
                {errors?.max_withdrawal_limit &&
                  touched?.max_withdrawal_limit && (
                    <span className='text-danger'>
                      {errors?.max_withdrawal_limit}
                    </span>
                  )}
              </div>
              <div className='col-md-4 mb-3'>
                <label htmlFor='default_rate'>
                  Withdrawal Penalty(%)<span className='text-danger'>*</span>
                </label>
                <input
                  type='text'
                  className={`form-control ${
                    errors?.withdrawal_penalty &&
                    touched?.withdrawal_penalty &&
                    "is-invalid"
                  }`}
                  name='withdrawal_penalty'
                  id='withdrawal_penalty'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='%'
                />
                {errors?.withdrawal_penalty && touched?.withdrawal_penalty && (
                  <span className='text-danger'>
                    {errors?.withdrawal_penalty}
                  </span>
                )}
              </div>
              <div class='form-check mt-1'>
                <input
                  class='form-check-input'
                  type='checkbox'
                  value={values?.restrict_withdrawal}
                  id='restrict_withdrawal'
                  name='restrict_withdrawal'
                  onChange={handleChange}
                />
                <label class='form-check-label' for=''>
                  Restrict withdrawal in the absence of savings activity until
                  maturity.
                </label>
              </div>
            </div>
          </div>
          <div className='border p-3 rounded-3 my-4 position-relative'>
            <h4 className='fw-semibold bg-white position-absolute profile-title'>
              Termination
            </h4>
            <div className='row'>
              <div className='col-md-4 mb-3'>
                <label htmlFor='default_rate'>
                  Penalty period (max. in months)
                  <span className='text-danger'>*</span>
                </label>
                <input
                  type='text'
                  className={`form-control ${
                    errors?.penalty_period &&
                    touched?.penalty_period &&
                    "is-invalid"
                  }`}
                  name='penalty_period'
                  id='penalty_period'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='5'
                />
                {errors?.penalty_period && touched?.penalty_period && (
                  <span className='text-danger'>{errors?.penalty_period}</span>
                )}
              </div>
              <div className='col-md-4 mb-3'>
                <label htmlFor='default_rate'>
                  Penalty Value (%)<span className='text-danger'>*</span>
                </label>
                <input
                  type='text'
                  className={`form-control ${
                    errors?.penalty_value &&
                    touched?.penalty_value &&
                    "is-invalid"
                  }`}
                  name='penalty_value'
                  id='penalty_value'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='%'
                />
                {errors?.penalty_value && touched?.penalty_value && (
                  <span className='text-danger'>{errors?.penalty_value}</span>
                )}
              </div>
              <div className='border p-3 rounded-3 my-4 position-relative'>
                <h4 className='fw-semibold bg-white position-absolute profile-title'>
                  Cool Off
                </h4>
                <div className='row'>
                  <div className='col-md-4 mb-3'>
                    <label htmlFor='default_rate'>
                      Cool off period (max. in days)
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      className={`form-control ${
                        errors?.cool_off_period &&
                        touched?.cool_off_period &&
                        "is-invalid"
                      }`}
                      name='cool_off_period'
                      id='cool_off_period'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder='5'
                    />
                    {errors?.cool_off_period && touched?.cool_off_period && (
                      <span className='text-danger'>{errors?.cool_off_period}</span>
                    )}
                  </div>
                  <div className='col-md-4 mb-3'>
                    <label htmlFor='default_rate'>
                      Cool off Penalty (%)<span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      className={`form-control ${
                        errors?.cool_off_value &&
                        touched?.cool_off_value &&
                        "is-invalid"
                      }`}
                      name='cool_off_value'
                      id='cool_off_value'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder='%'
                      value={values.cool_off_value}
                    />
                    {errors?.cool_off_value && touched?.cool_off_value && (
                      <span className='text-danger'>{errors?.cool_off_value}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              className='btn btn-info text-white me-3'
              onClick={() => accountingRef?.current?.click()}
            >
              <i className='mdi mdi-arrow-left me-1'></i>
              Previous
            </button>
            <button type='submit' className='btn btn-primary text-white '>
              Submit <i className='mdi mdi-arrow-right ms-1'></i>
            </button>
          </div>
        </div>
      </form>
      <button
        ref={preview}
        className='d-none'
        data-bs-toggle='modal'
        data-bs-target='#preview-policy'
      ></button>
      <SavingsPolicyPreview
        modal_id={"preview-policy"}
        data={data}
        policyCreateCloseRef={policyCreateCloseRef}
      />
    </>
  );
};

export default SavingsSettings;
